import { REDUCE_TOOLTIP_INFO } from '../../constants/actions/policy';

export function reduceTooltipInfo(payload) {
    return {
        type: REDUCE_TOOLTIP_INFO,
        payload,
    };
}
